import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getStoredUser, getUserToken, isTrue, themeColors } from "../../functions/themeAssets";
import "../common/saveThem.css";

const RESULT_KEY = "saveThemResult";

const readResult = () => {
  try {
    return JSON.parse(sessionStorage.getItem(RESULT_KEY) || "null");
  } catch {
    return null;
  }
};

export default function ThankYou() {
  const navigate = useNavigate();
  const { data: themeData } = useSelector((state) => state.theme);
  const [result, setResult] = useState(readResult);
  const [loading, setLoading] = useState(!readResult());
  const [leaderboard, setLeaderboard] = useState(null);
  const user = getStoredUser();
  const leaderboardEnabled = isTrue(themeData?.leaderboard_toggle);

  // Coming back later: read the saved score from the server
  useEffect(() => {
    if (result) return;
    if (!user) {
      navigate("/login", { replace: true });
      return;
    }
    fetch(`${process.env.REACT_APP_BACKEND_URL}/fetchReport`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${getUserToken(user)}` },
      body: JSON.stringify({ userId: user.userId }),
    })
      .then((r) => r.json())
      .then((json) => {
        if (json.success && json.report) {
          setResult({ points: json.report.points, total: json.report.total, time: json.report.time });
        } else {
          navigate("/rules", { replace: true });
        }
      })
      .catch(() => navigate("/rules", { replace: true }))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!user || !leaderboardEnabled) return undefined;
    let cancelled = false;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/getGameLeaderboard`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${getUserToken(user)}` },
      body: JSON.stringify({ userId: user.userId }),
    })
      .then((r) => r.json())
      .then((json) => {
        if (cancelled) return;
        if (json.success) setLeaderboard(json.data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leaderboardEnabled]);

  if (loading || !result) {
    return (
      <div className="st-loader">
        <div className="st-loader-spinner" />
      </div>
    );
  }

  const { text, box } = themeColors(themeData);
  const thanks = String(themeData?.custom_text_thank_you_page || "").trim();

  return (
    <div className="st-thanks" style={{ color: text, "--st-lb-box": box }}>
      <img src="/thankyou.gif" className="st-thanks-logo" alt="Thank you" />

      {leaderboardEnabled ? (
        <div className="st-leaderboard">
          <div className="st-lb-header">
            <span className="st-lb-col st-lb-col-rank">Rank</span>
            <span className="st-lb-col st-lb-col-name">Name</span>
            <span className="st-lb-col st-lb-col-points">Points</span>
            <span className="st-lb-col st-lb-col-time">Time</span>
          </div>

          {!leaderboard ? (
            <div className="st-lb-empty">Loading…</div>
          ) : leaderboard.top.length === 0 ? (
            <div className="st-lb-empty">No entries yet.</div>
          ) : (
            <div className="st-lb-rows">
              {[...leaderboard.top, ...(leaderboard.me ? [leaderboard.me] : [])].map((r) => {
                const isMe = String(r.userId) === String(user.userId);
                return (
                  <div key={r.rank} className={`st-lb-row ${isMe ? "st-lb-row-me" : ""}`}>
                    <span className="st-lb-col st-lb-col-rank">{r.rank}</span>
                    <span className="st-lb-col st-lb-col-name">{r.name}</span>
                    <span className="st-lb-col st-lb-col-points">{r.points}</span>
                    <span className="st-lb-col st-lb-col-time">{r.time}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      ) : (
        <div className="st-thanks-score">
          Your score is {result.points} out of {result.total} in {result.time} minutes.
        </div>
      )}

      {thanks && <div className="st-thanks-text">{thanks}</div>}
    </div>
  );
}
